const action = "DISCOVERY_STUDIO_FORECAST";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const CLEAR = action + '_CLEAR';
export const FAILURE = action + '_FAILURE';
// Manual re-run of the champion inference on the latest data. Kept as a
// distinct flow so the chart stays visible (only the button spins) while the
// fresh forecast is served, and the same response updates the view in place.
export const RERUN_REQUEST = action + '_RERUN_REQUEST';
export const RERUN_RESPONSE = action + '_RERUN_RESPONSE';
export const RERUN_FAILURE = action + '_RERUN_FAILURE';

export const fetchRequest = (payload) => ({
  type: REQUEST,
  payload
});

export const rerunRequest = (payload) => ({
  type: RERUN_REQUEST,
  payload
});

export const rerunSuccess = (response) => ({
  type: RERUN_RESPONSE,
  payload: response
});

export const rerunFailure = (error) => ({
  type: RERUN_FAILURE,
  payload: error
});

export const fetchSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

export const clearState = () => ({
  type: CLEAR
});

export const fetchFailure = (error) => ({
  type: FAILURE,
  payload: error
});
